// Lưu dữ liệu vào sessionStorage
/**
 
 * @param {string} key
 * @param {string} data

 */
export const saveToSessionStorage = (key, data) => {
    try {
        sessionStorage.setItem(key, JSON.stringify(data))
    } catch (error) {
        console.error('Error saving to sessionStorage:', error)
    }
}

// Lấy dữ liệu từ sessionStorage
export const getFromSessionStorage = (key) => {
    try {
        const storedData = sessionStorage.getItem(key)
        return storedData ? JSON.parse(storedData) : null
    } catch (error) {
        console.error('Error getting from sessionStorage:', error)
        return null
    }
}

// Xóa dữ liệu từ sessionStorage
export const removeFromSessionStorage = (key) => {
    try {
        sessionStorage.removeItem(key)
    } catch (error) {
        console.error('Error removing from sessionStorage:', error)
    }
}
